module.exports = __webpack_public_path__ + "img/sloat-relax.d2389eae.jpg";